import { customElement } from 'lit/decorators.js';
import { IReactionDisposer, reaction } from 'mobx';
import { TefComsCustomerAttributeBase } from '@common/customerAttributes/TefComsCustomerAttributeBase';
import { CustomerAttribute } from '@common/customerAttributes/types';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin';
import { Theme } from '@common/types/enum';
import { comsStore } from '@src/state/ComsStore';
import { templates } from './templates';

@customElement('tef-coms-customer-attribute')
export class TefComsCustomerAttribute extends TemplatingMixin(TefComsCustomerAttributeBase, Theme.OCCL, templates) {
  private disposer: IReactionDisposer;

  constructor() {
    super();
    this.disposer = reaction(() => this.customerAttributes, () => {
      this.requestUpdate();
    });
  }

  connectedCallback() {
    super.connectedCallback();
    // Only available here after store init and not on top of the class :(
    this.setTemplatingTheme(this.theme);
  }

  disconnectedCallback() {
    this.disposer();
  }

  /**
   * returns whether any cattr item has been modified relative to the original database state
   */
  get isModifiedFromInitial(): boolean {
    return comsStore.isCustomerAttributeModified(this.id);
  }

  get customerAttributes() {
    return comsStore.customerAttributes ?? [];
  }

  get theme() {
    return comsStore.config?.occlUri ? Theme.OCCL : Theme.TEFONE;
  }

  get userIsInRegisterFlow() {
    return !!comsStore.config?.isNewCustomer;
  }

  get userIsInEditMode() {
    return true;
  }

  saveCustomerAttributeToStore(customerAttribute: CustomerAttribute): void {
    comsStore.setCustomerAttribute(customerAttribute);
  }

  getTemplateFnFor(templateName: string) {
    return this.getTemplateFn(templateName);
  }

  get mainComponentTag() {
    return 'tef-coms4cs';
  }
}
